<div class="flex flex-wrap items-center justify-between gap-4 px-5 py-4">
    <!-- Results count -->
    <p class="text-sm text-slate-500">
        @if (tableController.count === tableController.filteredCount) {
            {{
                'total_results_count'
                    | translate: { count: tableController.count }
            }}
        }
        @if (tableController.count !== tableController.filteredCount) {
            {{
                'showing_filteredCount_results_from_count_total_results'
                    | translate
                        : {
                              filteredCount: tableController.filteredCount,
                              count: tableController.count,
                          }
            }}
        }
    </p>

    <!-- Pagination controls -->
    <div class="flex items-center gap-3">
        <!-- Page size selector -->
        <ng-select
            class="pagination-select"
            [items]="pageSizes"
            [searchable]="false"
            [clearable]="false"
            [ngModel]="tableController.filter.pageSize"
            (ngModelChange)="changePageSize($event)"
        >
        </ng-select>

        <!-- Page numbers -->
        <div class="flex items-center gap-1">
            <!-- Previous button -->
            <button
                class="rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm transition-colors"
                [ngClass]="{
                    'cursor-not-allowed text-slate-400':
                        tableController.filter.pageNumber === 0,
                    'text-slate-700 hover:bg-slate-50':
                        tableController.filter.pageNumber !== 0,
                }"
                [disabled]="tableController.filter.pageNumber === 0"
                (click)="
                    changePageNumber(tableController.filter.pageNumber - 1)
                "
            >
                <i class="fa-light fa-chevron-left rtl:-rotate-180"></i>
            </button>

            <!-- Number buttons -->
            @for (item of getShownPageNumbers(); track item) {
                <button
                    class="rounded-lg px-3 py-2 text-sm font-medium transition-colors"
                    [ngClass]="{
                        'bg-primary-600 text-white':
                            item === tableController.filter.pageNumber,
                        'border border-slate-200 bg-white text-slate-700 hover:bg-slate-50':
                            item !== tableController.filter.pageNumber,
                    }"
                    (click)="changePageNumber(item)"
                >
                    {{ item + 1 }}
                </button>
            }

            <!-- Next button -->
            <button
                class="rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm transition-colors"
                [ngClass]="{
                    'cursor-not-allowed text-slate-400':
                        tableController.filter.pageNumber ===
                        tableController.totalPages() - 1,
                    'text-slate-700 hover:bg-slate-50':
                        tableController.filter.pageNumber !==
                        tableController.totalPages() - 1,
                }"
                [disabled]="
                    tableController.filter.pageNumber ===
                    tableController.totalPages() - 1
                "
                (click)="
                    changePageNumber(tableController.filter.pageNumber + 1)
                "
            >
                <i class="fa-light fa-chevron-right rtl:-rotate-180"></i>
            </button>
        </div>
    </div>
</div>
